import { Link, useNavigate } from "react-router-dom";
import clsx from "clsx";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import styles from "./NotificationButton.module.scss";
import { runWithGameLeaveGuard } from "Pages/Games/gameLeaveGuardRegistry";
import { getSafeHref } from "Utils/safeUrl";

const isExternalUrl = (value = "") => /^(https?:)?\/\//i.test(value);

export function NotificationButton({
  children,
  variant = "primary",
  to,
  onClick,
  className,
  showIcon = true,
  ...rest
}) {
  const navigate = useNavigate();
  const classNames = clsx(styles.button, styles[variant], className);
  const safeTo = getSafeHref(to, {
    allowedProtocols: ["http:", "https:"],
    fallback: "",
  });
  const content = (
    <>
      <span>{children}</span>
      {showIcon && <ArrowForwardIcon className={styles.icon} />}
    </>
  );

  if (to && !safeTo) {
    return (
      <button type="button" className={classNames} onClick={onClick} {...rest}>
        {content}
      </button>
    );
  }

  if (safeTo && isExternalUrl(safeTo)) {
    return (
      <a
        href={safeTo}
        className={classNames}
        onClick={onClick}
        rel="noreferrer"
        {...rest}
      >
        {content}
      </a>
    );
  }

  if (safeTo) {
    const handleInternalClick = (event) => {
      onClick?.(event);
      if (event.defaultPrevented) return;

      event.preventDefault();
      runWithGameLeaveGuard(() => navigate(safeTo));
    };

    return (
      <Link
        to={safeTo}
        className={classNames}
        onClick={handleInternalClick}
        {...rest}
      >
        {content}
      </Link>
    );
  }

  return (
    <button type="button" className={classNames} onClick={onClick} {...rest}>
      {content}
    </button>
  );
}
